import CampaignPage from './campaign'

export { CampaignPage }
